const menuBtn = document.querySelector("button.mobile-menu-button");
const menu = document.querySelector(".mobile-menu");
const menuHeight = menu.dataset.h;

menu.classList.remove("hidden");

menuBtn.addEventListener("click", () => {
    //menu.classList.toggle("hidden");
    //menu.classList.toggle("h-0");
    //menu.classList.toggle("h-["+menuHeight+"rem]");
    //document.body.classList.toggle("menu-open");

    if (document.body.classList.contains("menu-open")) {
      menu.style.height = "";
      document.body.classList.add("menu-hiding");
      setTimeout(() => {
        document.body.classList.remove("menu-open");
        document.body.classList.remove("menu-hiding");
      }, 200);
    } else {
      document.body.classList.add("menu-open");
      if (window.innerWidth < 768) {
        menu.style.height = menuHeight + "rem";
      } else {
        menu.style.height = "8.5rem";
      }
    }
});

const breakpoint = window.matchMedia("(min-width:1024px)");
function breakpointChecker() {
    // if larger viewport
    if (breakpoint.matches === true) {
      document.body.classList.remove("menu-open");
      menu.style.height = "";

      // or/and do nothing
      return;
      // else if a small viewport
    } else if (breakpoint.matches === false) {
      return;
    }
}
breakpointChecker();
breakpoint.addListener(breakpointChecker);
